import { Injectable } from '@angular/core';
import { Node } from '@alfresco/js-api';
import { LockService } from '@alfresco/adf-content-services';

@Injectable({
  providedIn: 'root',
})
export class WkLockService {
  constructor(private readonly lockService: LockService) {}

  isLocked(node: Node) {
    return this.lockService.isLocked(node);
  }
}
